export default {
  state: {
    listeUms: []
  },
  mutations: {
    impostaUms(state, data) {
      var index = state.listeUms.findIndex(x => {
        return x.cate == data.cate;
      });
      if (index == -1) {
        state.listeUms.push(data);
      } else {
        state.listeUms[index] = data;
      }
    },
    clearUms(state) {
      state.listeUms = [];
    }
  },
  getters: {
    getListByCate: state => categoria => {
      var x = state.listeUms.find(lista => lista.cate === categoria);
      if (x == null) {
        return null;
      } else {
        //alert(x.cate);
        //alert(x.listaUM);
        return x.listaUM;
      }
    },
    getUmsShow: state => umsId => {
      var x = umsId;
      state.listeUms.forEach(l => {
        l.listaUM.forEach(xum => {
          if (xum.id == umsId) {
            x = xum.descrizione;
          }
        });
      });

      return x;
    }
  }
};
